import { Checkbox } from '@material-ui/core';
import { useEffect, useRef, useState, useContext, useCallback, useMemo } from 'react';
import Styles from '../generate-cards/GenerateCards.style';
import table from 'assets/svgs/table.svg';
import NothingFound from './Components/NothingFound';
import SelectTableFromLeftSide from 'assets/svgs/SelectTableFromLeftSide.svg';
import { TextField, InputAdornment, Box } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { TableView } from './TableSchema.component';
import { Button } from '@material-ui/core';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { IconButton } from '@material-ui/core';
import { MenuItemsList } from './Components/MenuItemsList.component';
import DeleteOutlineSharpIcon from '@material-ui/icons/DeleteOutlineSharp';
import {
	setSelectedTemplate,
	resetSubTempates,
	getTempatesSuccess,
	saveCustomDataset
} from '../Template.actions';
import ClearIcon from '@material-ui/icons/Clear';
import {
	saveItemShareStatus,
	setSelectedList,
	setFilterList,
	clearPreview,
	resetDraft,
	setPrevFilterList
} from '../../Preview/Preview.actions';
import { useSelector, useDispatch } from 'react-redux';
import { UserPortalContext } from 'context/appcontext';
import { handleBuildReport } from '../quick-report/QuickReport.utils';
import { useNavigate } from 'react-router-dom';
import SaveDatasetModel from './Components/SaveDatasetModal';
import {
	setCustomDatasetName,
	updateCustomDataset,
	setDatasetExistsFlag
} from '../Template.actions';
import {
	ABC,
	TIME_BUSINESS_NAMES,
	CUSTOM_DATASET,
	CUSTOM_DATASET_MODAL_SUBHEADING,
	SAVE_DATASET,
	CUSTOM_DATASET_MODAL_WARNING,
	SELECT_THIS_TABLE,
	UPDATE,
	OKAY,
	CANCEL_BUTTON,
	CUSTOM_DATASET_TABLE_DETAILS_SUBHEADING,
	SELECTED_TABLES,
	CLEAR_ALL_CAPITALIZE,
	TABLE_DETAILS_LABEL,
	ALL_TABLES,
	CUSTOM_DATASET_SEARCH_PLACEHOLDER
} from 'constants/constant';
import { deepClone } from 'helper/helper';
import {
	getResultObject,
	assignDimensionsAndMeasures,
	isCustomDatasetModular,
	getDfltFilter,
	isUnsavedCustomDataset
} from 'helper/utils';
import { trackEventInfo } from 'helper/analytics';
import { CUSTOM_DATASET_ID } from 'constants/constant';
import { PAGE_ID, EVENTS, ACTION_ON } from 'constants/tracker';

const CUSTOM_TEMPLATE_ROW_OPTIONS_LIST = [
	{
		disabled: false,
		name: TABLE_DETAILS_LABEL,
		id: TABLE_DETAILS_LABEL
	}
];

export const CustomTemplateModal = ({
	setHeader,
	setActions,
	closeModalFn,
	selectedCustomTemplate,
	templateData,
	isEditMode,
	selectedTables
}) => {
	const [selectedTablesList, setSelectedTablesList] = useState(() => {
		if (isEditMode) {
			return selectedTables ?? [];
		}
		return [];
	});
	const [availableTablesList, setAvailableTablesList] = useState([]);
	const [tableView, setTableView] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [openSaveModal, setOpenSaveModal] = useState(false);
	const [tableSelectionData, setTableSelectionData] = useState();
	const [isSaveSelected, setIsSaveSelected] = useState(true);
	const classes = Styles();
	const dataRef = useRef();
	const selectedItemId = selectedCustomTemplate?.templateId;
	const [anchorElement, setAnchorElement] = useState();
	const anchorElementRowDetails = useRef();
	const dispatch = useDispatch();
	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);
	const sbuDBTechNames = useSelector((state) => state.templateReducer.sbuDimDBTechName);
	const sbuDepartments = useSelector((state) => state.templateReducer.sbuDepartments);
	const selectedView = useSelector((state) => state.templateReducer.selectedView);
	const customDatasetDetails = useSelector((state) => state.templateReducer.customDatasetDetails);
	const savedCustomDatasets = useSelector((state) => state.templateReducer.savedCustomDatasets);
	const { CDTourStepIndex } = useSelector((state) => state.tourReducer);
	const portalUserContext = useContext(UserPortalContext);
	const filterList = useSelector((state) => state.previewReducer.filterList);
	const selectedItemList = useSelector((state) => state.previewReducer.selectedList);
	const { userDetails } = portalUserContext;
	const { userPersona, blackOut } = userDetails?.result;
	const navigate = useNavigate();

	const savedCustomDatasetsNames = useMemo(() => {
		return (savedCustomDatasets ?? []).map((dataset) => dataset.customDatasetName);
	}, [savedCustomDatasets]);

	useEffect(() => {
		const customTableNames = customDatasetDetails.tablesInfo.map((item) => {
			let checked = false;
			const editTableValue = selectedTables?.find(
				(selectedTable) => selectedTable?.name === item?.tableName
			);
			if (editTableValue) {
				checked = editTableValue.checked;
			}
			return {
				name: item?.tableName,
				checked: checked,
				dimensions: item?.dimensions,
				measures: item?.measures
			};
		});
		dataRef.current = customTableNames;
		setAvailableTablesList([...dataRef.current]);
	}, []);

	const onOpenSaveModal = useCallback(() => {
		setOpenSaveModal(true);
	}, []);

	const onCloseSaveModal = useCallback(() => {
		setOpenSaveModal(false);
	}, []);

	const isDuplicateName = (datasetName) => {
		return savedCustomDatasetsNames.some(
			(name) => name.toLowerCase().trim() === datasetName.toLowerCase().trim()
		);
	};

	useEffect(() => {
		switch (CDTourStepIndex) {
			case 2:
				if (availableTablesList.length > 0) {
					handleTableSelection(availableTablesList[0]);
				}
				break;
			case 4:
				onTriggerSaveEdit();
				break;
			default:
				break;
		}
	}, [CDTourStepIndex]);

	const triggerSaveEditTemplate = useCallback(
		// if this function changes, change the dependency array
		() => {
			if (selectedTablesList.length === 0) {
				return;
			}

			const selectedList = selectedTablesList.map((item) => item.name);

			const selectedTableObjects = customDatasetDetails.tablesInfo.filter((item) =>
				selectedList.includes(item.tableName)
			);

			const result = {
				sortOrder: 1,
				folderNames: [...customDatasetDetails.tableNames],
				templateId: selectedItemId,
				dimensions: [],
				measures: [],
				filter: customDatasetDetails.filter,
				filterWeekly: customDatasetDetails.filterWeekly,
				filterWeeklyMultiWindow: customDatasetDetails.filterWeeklyMultiWindow,
				view: customDatasetDetails?.view ?? ABC,
				defaultFilters: customDatasetDetails?.defaultFilters,
				tables: selectedList
			};

			selectedTableObjects.forEach((selectedTable) => {
				if (selectedTable.dimensions) {
					result.dimensions = [...result.dimensions, ...selectedTable.dimensions];
				}
				if (selectedTable.measures) {
					result.measures = [...result.measures, ...selectedTable.measures];
				}
			});

			const isMod = isCustomDatasetModular(selectedTableObjects);

			if (!isMod) {
				result.time = customDatasetDetails?.time;
			}

			const index = templateData.findIndex((item) => item.templateId == result.templateId);
			if (index > -1) {
				const temp = [...templateData];
				temp.splice(index, 1);
				dispatch(getTempatesSuccess([...temp, result]));
			} else {
				dispatch(getTempatesSuccess([...templateData, result]));
				dispatch(setCustomDatasetName({ datasetName: '' }));
			}

			dispatch(resetSubTempates());
			dispatch(
				setSelectedTemplate({
					templateId: result.templateId,
					view: result.view,
					filter: result.filter,
					filterWeekly: result.filterWeekly,
					filterWeeklyMultiWindow: result.filterWeeklyMultiWindow
				})
			);

			const dispatchFilterList = (list) => {
				dispatch(setFilterList(list));
				dispatch(setPrevFilterList(list));
			};

			const dispatchSelectedList = (list) => {
				dispatch(setSelectedList(list));
			};

			handleBuildReport(
				selectedTemplate,
				[result],
				userPersona,
				blackOut,
				sbuDBTechNames,
				sbuDepartments,
				selectedView,
				dispatchFilterList,
				dispatchSelectedList
			);

			dispatch(clearPreview([]));
			dispatch(resetDraft());
			dispatch(saveItemShareStatus({ prev: false, curr: false }));
			onCloseSaveModal(false);
			navigate('/preview');
		},
		[selectedTablesList]
	);

	const onTriggerSaveEdit = useCallback(
		(shouldUpdate) => {
			if (shouldUpdate) {
				const isUnsavedCustomDS = isUnsavedCustomDataset(selectedCustomTemplate?.templateId);
				// Updating an existing custom dataset
				const editedDataset = deepClone(selectedCustomTemplate);
				const selectedList = selectedTablesList.map((item) => item.name);
				editedDataset['tables'] = selectedList;

				const selectedTableObjects = customDatasetDetails.tablesInfo.filter((item) =>
					selectedList.includes(item.tableName)
				);

				// If it is a saved custom dataset, save it to the BE
				if (!isUnsavedCustomDS) {
					dispatch(updateCustomDataset(editedDataset));
				}

				let result = getResultObject(selectedItemId, customDatasetDetails, selectedList);

				result = assignDimensionsAndMeasures(result, selectedTableObjects);

				const isMod = isCustomDatasetModular(selectedTableObjects);

				if (!isMod) {
					result.time = customDatasetDetails?.time;
					const filterListWithTimeFilter = filterList.some((filter) =>
						TIME_BUSINESS_NAMES.includes(filter?.businessName)
					);
					// if there is no filter on Time, then add an empty week filter to make Time required
					if (!filterListWithTimeFilter) {
						const defaultFilterSel = getDfltFilter([result]);
						const newFilterList = [...deepClone(filterList), ...defaultFilterSel];
						dispatch(setFilterList(newFilterList));
					}
				} else {
					const filterListWithoutTime = filterList.filter((filter) => {
						if (TIME_BUSINESS_NAMES.includes(filter?.businessName)) {
							return false;
						} else {
							return true;
						}
					});
					const selectedListWithoutTime = selectedItemList.filter((selectedItem) => {
						if (TIME_BUSINESS_NAMES.includes(selectedItem?.businessName)) {
							return false;
						} else {
							return true;
						}
					});
					dispatch(setFilterList(filterListWithoutTime));
					dispatch(setSelectedList(selectedListWithoutTime));
				}

				const index = templateData.findIndex((item) => item.templateId == result.templateId);
				if (index > -1) {
					const temp = [...templateData];
					temp.splice(index, 1);
					dispatch(getTempatesSuccess([...temp, result]));
				} else {
					dispatch(getTempatesSuccess([...templateData, result]));
				}

				dispatch(
					setSelectedTemplate({
						templateId: result.templateId,
						view: result.view,
						filter: result.filter,
						filterWeekly: result.filterWeekly,
						filterWeeklyMultiWindow: result.filterWeeklyMultiWindow
					})
				);

				closeModalFn(false);
				trackEventInfo({
					type: EVENTS.CLICK,
					actionOn: ACTION_ON.CUSTOM_DATASET_UPDATE,
					location: PAGE_ID.TEMPLATES
				});
			} else {
				// Saving/Previewing a brand new "custom dataset"
				if (isSaveSelected) {
					onOpenSaveModal();
				} else {
					trackEventInfo({
						type: EVENTS.CLICK,
						actionOn: ACTION_ON.CUSTOM_DATASET_UNSAVED,
						location: PAGE_ID.TEMPLATES
					});
					triggerSaveEditTemplate();
				}
			}
		},
		[
			isSaveSelected,
			onOpenSaveModal,
			triggerSaveEditTemplate,
			selectedCustomTemplate,
			selectedTablesList
		]
	);

	const onSaveModal = (datasetName) => {
		let isIdenticalToExisting = null;
		const selectedList = selectedTablesList.map((item) => item.name);
		const requestBody = {
			customDatasetName: datasetName,
			customDatasetDesc: '',
			tables: selectedList
		};
		for (let i = 0; i < savedCustomDatasets.length; i++) {
			const datasetTables = savedCustomDatasets[i].tables;
			if (datasetTables.length == selectedList.length) {
				const isIdentical = datasetTables.every((table) => selectedList.includes(table));
				if (isIdentical) {
					isIdenticalToExisting = savedCustomDatasets[i];
					break;
				}
			} else continue;
		}
		if (isIdenticalToExisting) {
			const { templateId, customDatasetName } = isIdenticalToExisting;
			const selectedTableObjects = customDatasetDetails.tablesInfo.filter((item) =>
				selectedList.includes(item.tableName)
			);

			const result = {
				sortOrder: 1,
				folderNames: [...customDatasetDetails.tableNames],
				templateId,
				dimensions: [],
				measures: [],
				filter: customDatasetDetails.filter,
				filterWeekly: customDatasetDetails.filterWeekly,
				filterWeeklyMultiWindow: customDatasetDetails.filterWeeklyMultiWindow,
				view: customDatasetDetails?.view ?? ABC,
				defaultFilters: customDatasetDetails?.defaultFilters
			};

			selectedTableObjects.forEach((selectedTable) => {
				if (selectedTable.dimensions) {
					result.dimensions = [...result.dimensions, ...selectedTable.dimensions];
				}
				if (selectedTable.measures) {
					result.measures = [...result.measures, ...selectedTable.measures];
				}
			});

			const isMod = isCustomDatasetModular(selectedTableObjects);

			if (!isMod) {
				result.time = customDatasetDetails?.time;
			}

			const index = templateData.findIndex((item) => item.templateId == result.templateId);
			if (index > -1) {
				const temp = [...templateData];
				temp.splice(index, 1);
				dispatch(getTempatesSuccess([...temp, result]));
			} else {
				dispatch(getTempatesSuccess([...templateData, result]));
			}
			dispatch(setCustomDatasetName({ datasetName: customDatasetName }));

			dispatch(resetSubTempates());
			dispatch(
				setSelectedTemplate({
					templateId: result.templateId,
					view: result.view,
					filter: result.filter,
					filterWeekly: result.filterWeekly,
					filterWeeklyMultiWindow: result.filterWeeklyMultiWindow
				})
			);

			const dispatchFilterList = (list) => {
				dispatch(setFilterList(list));
				dispatch(setPrevFilterList(list));
			};

			const dispatchSelectedList = (list) => {
				dispatch(setSelectedList(list));
			};

			handleBuildReport(
				selectedTemplate,
				[result],
				userPersona,
				blackOut,
				sbuDBTechNames,
				sbuDepartments,
				selectedView,
				dispatchFilterList,
				dispatchSelectedList
			);

			dispatch(clearPreview([]));
			dispatch(resetDraft());
			dispatch(saveItemShareStatus({ prev: false, curr: false }));
			dispatch(setDatasetExistsFlag(true));
			navigate('/preview');
		} else {
			dispatch(saveCustomDataset(requestBody));
			triggerSaveEditTemplate();
			// Analytics
			if (isSaveSelected) {
				trackEventInfo({
					type: EVENTS.CLICK,
					actionOn: ACTION_ON.CUSTOM_DATASET_SAVED,
					location: PAGE_ID.TEMPLATES
				});
			}
		}
	};

	useEffect(() => {
		if (tableView) {
			setHeader(
				<TableViewHeaderComponent
					title={tableSelectionData.name}
					backFn={() => {
						setTableView(false);
					}}
				/>
			);
			setActions(
				<TableViewActionsComponent
					closeModalFn={() => {
						setTableView(false);
						if (!tableSelectionData.checked) {
							handleTableSelection(tableSelectionData);
						}
					}}
				/>
			);
		} else {
			const shouldDisableOkay = selectedTablesList.length === 0;
			setHeader(<CustomDatasetHeaderComponent />);
			setActions(
				<CustomDatasetActionsComponent
					closeModalFn={closeModalFn}
					isSaveSelected={isSaveSelected}
					checkboxSelectFunction={() => {
						setIsSaveSelected(!isSaveSelected);
					}}
					triggerSaveEdit={onTriggerSaveEdit}
					selectedItemId={selectedItemId}
					shouldDisableOkay={shouldDisableOkay}
					isEditMode={isEditMode}
				/>
			);
		}
	}, [tableView, isSaveSelected, selectedTablesList, onTriggerSaveEdit]);

	const handleMenuEvents = (item) => {
		if (item.id == TABLE_DETAILS_LABEL) {
			setTableSelectionData(anchorElementRowDetails.current);
			setTableView(true);
			trackEventInfo({
				type: EVENTS.CLICK,
				actionOn: `${ACTION_ON.CUSTOM_DATASET_TABLE_DETAILS} - ${anchorElementRowDetails?.current?.name}`,
				location: PAGE_ID.TEMPLATES
			});
		}
		setAnchorElement(null);
		anchorElementRowDetails.current = null;
	};

	const handleTableSelection = (tableObj) => {
		const index = availableTablesList.findIndex((item) => item.name == tableObj.name);
		const isChecked = availableTablesList[index].checked;

		if (!isChecked) {
			setSelectedTablesList([...selectedTablesList, tableObj]);
		} else {
			const indexToSplice = selectedTablesList.findIndex((item) => item.name == tableObj.name);
			if (indexToSplice > -1) {
				selectedTablesList.splice(indexToSplice, 1);
				setSelectedTablesList([...selectedTablesList]);
			}
		}
		availableTablesList[index].checked = !isChecked;
		setAvailableTablesList([...availableTablesList]);
	};

	const handleSearchChange = (e) => {
		const newSearchText = e.currentTarget.value;
		setSearchText(newSearchText);
		if (!newSearchText.length) {
			setAvailableTablesList([...dataRef.current]);
			return;
		}
		const filteredList = dataRef.current.filter((item) => {
			// Search for the name of the table
			if (item.name.toLocaleLowerCase().includes(newSearchText.toLocaleLowerCase())) {
				return true;
			}
			// If the user searches for the name of a dimension
			if (
				item?.dimensions?.find((dimension) =>
					dimension.businessName.toLocaleLowerCase().includes(newSearchText.toLocaleLowerCase())
				)
			) {
				return true;
			}
			// If the user searches for the name of a metric
			if (
				item?.measures?.find((measure) =>
					measure.businessName.toLocaleLowerCase().includes(newSearchText.toLocaleLowerCase())
				)
			) {
				return true;
			}
			return false;
		});
		setAvailableTablesList(filteredList);
	};

	const handleClearSearchText = () => {
		setSearchText('');
		setAvailableTablesList([...dataRef.current]);
	};

	const getTableInfo = ({ name }) => {
		const filteredData = customDatasetDetails.tablesInfo.find((item) => item.tableName === name);
		const { measures = [], dimensions = [] } = filteredData;
		return [
			...measures?.map((measure) => ({
				...measure,
				type: measure?.dataType === 'date' ? 'Time' : 'Metric'
			})),
			...dimensions?.map((dimension) => ({
				...dimension,
				type: dimension?.dataType === 'date' ? 'Time' : 'Dimension'
			}))
		];
	};

	const onRemoveAllSelectdItems = () => {
		setSelectedTablesList([]);
		setAvailableTablesList(
			(availableTablesList ?? []).map((item) => ({ ...item, checked: false }))
		);
	};

	const onDontSave = () => {
		setOpenSaveModal(false);
	};

	const showClearAllTextIcon = searchText.length > 0;

	return (
		<>
			<div style={{ height: '100%', display: tableView ? 'none' : 'flex', overflow: 'hidden' }}>
				<div id="leftPanel" style={{ width: '50%', padding: '15px', position: 'relative' }}>
					<div style={{ fontSize: '14px', fontWeight: '700' }}>{ALL_TABLES}</div>
					<div style={{ margin: '8px 0' }}>
						<TextField
							fullWidth
							id="outlined-basic"
							placeholder={CUSTOM_DATASET_SEARCH_PLACEHOLDER}
							variant="outlined"
							size="small"
							value={searchText}
							onChange={(e) => {
								handleSearchChange(e);
							}}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon className={classes.searchIcon} />
									</InputAdornment>
								),
								endAdornment: showClearAllTextIcon ? (
									<InputAdornment
										className={classes.clearIcon}
										position="end"
										onClick={handleClearSearchText}>
										<ClearIcon />
									</InputAdornment>
								) : (
									<></>
								)
							}}
						/>
					</div>
					{!availableTablesList.length ? (
						<div
							style={{
								display: 'flex',
								flex: 1,
								alignItems: 'center',
								justifyContent: 'center'
							}}>
							<NothingFound searchKeyword={searchText} />
						</div>
					) : (
						<div style={{ overflow: 'auto', height: 'calc(100% - 62px)' }}>
							{availableTablesList.map((item) => {
								return (
									<div
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											marginTop: '5px'
										}}
										key={item.name}>
										<span style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox
												id={`available_checkbox_${item.name}`}
												className={classes.checkbox}
												checked={item.checked}
												onClick={() => {
													handleTableSelection(item);
												}}
											/>
											<img className={classes.spotIconCls} src={table} alt="spot-icon"></img>
											<span>{item.name}</span>
										</span>
										<span style={{ paddingRight: '25px', cursor: 'pointer' }}>
											<IconButton
												id={`metadata-more-${item.name}`}
												aria-label="metadata-more"
												size="small"
												className={classes.crossButton}
												onClick={(e) => {
													e.stopPropagation();
													anchorElementRowDetails.current = item;
													setAnchorElement(e.currentTarget);
												}}>
												<MoreHorizIcon fontSize="small" />
											</IconButton>
										</span>
									</div>
								);
							})}
						</div>
					)}
				</div>
				<div
					id="rightPanel"
					style={{
						backgroundColor: '#F8F8F8',
						width: '50%',
						padding: '15px',
						position: 'relative'
					}}>
					<div style={{ fontSize: '14px', fontWeight: '700' }}>{SELECTED_TABLES}</div>
					<Box display="flex" flexDirection="row-reverse">
						<Button
							disabled={selectedTablesList.length === 0}
							className={classes.clearAllBtn}
							onClick={onRemoveAllSelectdItems}
							startIcon={<DeleteOutlineSharpIcon />}>
							{CLEAR_ALL_CAPITALIZE}
						</Button>
					</Box>
					<br />
					{!selectedTablesList.length && (
						<div className={classes.noItemFoundImageStyle}>
							<img
								className={classes.spotIconCls}
								src={SelectTableFromLeftSide}
								alt="spot-icon"></img>
						</div>
					)}
					<div style={{ overflow: 'auto', height: 'calc(100% - 65px)' }}>
						{selectedTablesList.map((item) => {
							return (
								<div
									key={item.name}
									style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
									<span style={{ display: 'flex', alignItems: 'center' }}>
										<img className={classes.spotIconCls} src={table} alt="spot-icon"></img>
										<div>{item.name}</div>
									</span>
									<span
										style={{ paddingRight: '15px', cursor: 'pointer' }}
										onClick={() => {
											handleTableSelection(item);
										}}>
										x
									</span>
								</div>
							);
						})}
					</div>
				</div>
			</div>
			<MenuItemsList
				optionsList={CUSTOM_TEMPLATE_ROW_OPTIONS_LIST}
				anchorEl={anchorElement}
				handleEvents={handleMenuEvents}
				setAnchorEl={setAnchorElement}
			/>
			{tableView && <TableView tablesInfo={getTableInfo(tableSelectionData)} />}
			{isSaveSelected && openSaveModal && (
				<SaveDatasetModel
					open={openSaveModal}
					onClose={onCloseSaveModal}
					onDontSave={onDontSave}
					onSaveModal={onSaveModal}
					isDuplicateName={isDuplicateName}
				/>
			)}
		</>
	);
};

const CustomDatasetHeaderComponent = () => {
	return (
		<>
			<div style={{ fontSize: '24px', fontWeight: '700' }}>{CUSTOM_DATASET}</div>
			<div style={{ fontSize: '12px', color: '#74767C' }}>{CUSTOM_DATASET_MODAL_SUBHEADING}</div>
		</>
	);
};

const TableViewHeaderComponent = ({ title, backFn }) => {
	return (
		<>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<ArrowBackIcon
					onClick={() => {
						backFn();
					}}
				/>
				<div style={{ marginLeft: '15px' }}>
					<div id={'tableHeaderTitle'} style={{ fontSize: '24px', fontWeight: '700' }}>
						{title}
					</div>
				</div>
			</div>
			<div style={{ fontSize: '12px', color: '#74767C', marginLeft: '40px' }}>
				{CUSTOM_DATASET_TABLE_DETAILS_SUBHEADING}
			</div>
		</>
	);
};

const CustomDatasetActionsComponent = ({
	closeModalFn,
	shouldDisableOkay,
	isSaveSelected,
	checkboxSelectFunction,
	triggerSaveEdit,
	selectedItemId,
	isEditMode
}) => {
	const classes = Styles();
	const shouldUpdate = isEditMode ? true : selectedItemId !== CUSTOM_DATASET_ID;
	return (
		<Box display="flex" width="100%">
			<Box flexGrow={1}>
				<Box>
					{!shouldUpdate && (
						<>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<Checkbox
									id="save-dataset-checkbox"
									className={classes.saveCheckbox}
									checked={isSaveSelected}
									onClick={checkboxSelectFunction}
								/>
								<span>{SAVE_DATASET}</span>
							</div>
							<span className={classes.saveDatasetWarning}>{CUSTOM_DATASET_MODAL_WARNING}</span>
						</>
					)}
				</Box>
			</Box>
			<Box>
				<Button
					className={classes.cancelButton}
					onClick={() => {
						closeModalFn(false);
					}}
					variant="outlined">
					{CANCEL_BUTTON}
				</Button>
				<Button
					id={'submitButton'}
					className={classes.modalPrimaryButtons}
					disabled={shouldDisableOkay}
					onClick={() => triggerSaveEdit(shouldUpdate)}
					variant="outlined">
					{shouldUpdate ? UPDATE : OKAY}
				</Button>
			</Box>
		</Box>
	);
};

const TableViewActionsComponent = ({ closeModalFn }) => {
	const classes = Styles();
	return (
		<Button
			className={classes.modalPrimaryButtons}
			onClick={() => {
				closeModalFn();
			}}
			variant="outlined">
			{SELECT_THIS_TABLE}
		</Button>
	);
};
